import moduleCollapsible from '../../modules/module--collapsible';

export default function() {
    const sparklines = moduleCollapsible.add({
        block: '.collapsible--sparkline',
        elToggle: '.collapsible__toggle--sparkline',
        elContent: '.collapsible__content--sparkline',
        elCloseClassName: 'collapsible__close--sparkline',
        closeOutside: false,
        closeAny: false,
        closeOthers: true,
        callbackBuilt({ elContent, elToggle, elCloseClassName }) {
            return function callback() {
                const $elSparkline = $('.sparklines');
                if (!$(elContent).has(`.${elCloseClassName}`).length)
                    $(`${elContent} .card`).prepend(
                        $(`<button class="${elCloseClassName}"><span class="k-icon k-i-x k-icon-md"></span></button>`)
                    );
                // Close currently open collapsibles/sparklines when switching tabs
                // Otherwise you could close them on outside click?
                $('.menu-topbar__link').on('click', function() {
                    sparklines.close($(elToggle));
                    $elSparkline.css('min-height', '').removeClass('open');
                });
            };
        },
        callbackOpenAfter({ elCloseClassName }, { $activeBlock, $activeToggle, $activeContent }) {
            const $elSparkline = $('.sparklines');
            // Pass sparkline name to chart before triggering the event
            // PageUpdate, so chart knows the name to build
            const sparklineClickedId = $activeToggle.find('.sparkline').attr('id');
            if (sparklineClickedId) $elSparkline.find('.chart').attr('chart-name', sparklineClickedId);

            // Runs charts
            $(document).trigger('on:PageUpdate');

            // Make Vertical Space for chart pushing content down with
            // absolutely positioned element.
            $activeBlock
                .closest('.sparklines')
                .css('min-height', $activeContent.find('.sparklines__chart').outerHeight(true))
                .addClass('open');

            // Handle Close
            $(`.${elCloseClassName}`).on('click', function() {
                sparklines.close($activeToggle);
                $elSparkline.css('min-height', '').removeClass('open');
            });
        }
    });
}
